/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BudgetIn,
  BudgetOut,
  ExportReportParams,
  GetBudgetParams,
  GetReportParams,
  HTTPValidationError,
  ReportName,
  ReportOut
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getBudgetResponse200 = {
  data: BudgetOut
  status: 200
}

export type getBudgetResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getBudgetResponseSuccess = (getBudgetResponse200) & {
  headers: Headers;
};
export type getBudgetResponseError = (getBudgetResponse422) & {
  headers: Headers;
};

export type getBudgetResponse = (getBudgetResponseSuccess | getBudgetResponseError)

export const getGetBudgetUrl = (params: GetBudgetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/budget?${stringifiedParams}` : `/api/reports/budget`
}

/**
 * @summary Get Budget
 */
export const getBudget = async (params: GetBudgetParams, options?: Parameters<typeof apiFetch>[1]): Promise<getBudgetResponse> => {

  return apiFetch<getBudgetResponse>(getGetBudgetUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBudgetQueryKey = (params?: GetBudgetParams,) => {
    return [
    `/api/reports/budget`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetBudgetQueryOptions = <TData = Awaited<ReturnType<typeof getBudget>>, TError = HTTPValidationError>(params: GetBudgetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBudget>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBudgetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBudget>>> = ({ signal }) => getBudget(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBudget>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBudgetQueryResult = NonNullable<Awaited<ReturnType<typeof getBudget>>>
export type GetBudgetQueryError = HTTPValidationError


export function useGetBudget<TData = Awaited<ReturnType<typeof getBudget>>, TError = HTTPValidationError>(
 params: GetBudgetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBudget>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBudget>>,
          TError,
          Awaited<ReturnType<typeof getBudget>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBudget<TData = Awaited<ReturnType<typeof getBudget>>, TError = HTTPValidationError>(
 params: GetBudgetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBudget>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBudget>>,
          TError,
          Awaited<ReturnType<typeof getBudget>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBudget<TData = Awaited<ReturnType<typeof getBudget>>, TError = HTTPValidationError>(
 params: GetBudgetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBudget>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Budget
 */

export function useGetBudget<TData = Awaited<ReturnType<typeof getBudget>>, TError = HTTPValidationError>(
 params: GetBudgetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBudget>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBudgetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type saveBudgetResponse200 = {
  data: BudgetOut
  status: 200
}

export type saveBudgetResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type saveBudgetResponseSuccess = (saveBudgetResponse200) & {
  headers: Headers;
};
export type saveBudgetResponseError = (saveBudgetResponse422) & {
  headers: Headers;
};

export type saveBudgetResponse = (saveBudgetResponseSuccess | saveBudgetResponseError)

export const getSaveBudgetUrl = () => {




  return `/api/reports/budget`
}

/**
 * @summary Save Budget
 */
export const saveBudget = async (budgetIn: BudgetIn, options?: Parameters<typeof apiFetch>[1]): Promise<saveBudgetResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<saveBudgetResponse>(getSaveBudgetUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(budgetIn)
  }
);}





export const getSaveBudgetMutationKey = () => ['saveBudget'] as const;

export const getSaveBudgetMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveBudget>>, TError,SaveBudgetMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveBudget>>, TError,SaveBudgetMutationVariables, TContext> => {

const mutationKey = getSaveBudgetMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveBudget>>, SaveBudgetMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  saveBudget(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveBudgetMutationResult = NonNullable<Awaited<ReturnType<typeof saveBudget>>>
    export type SaveBudgetMutationBody = BudgetIn
    export type SaveBudgetMutationError = HTTPValidationError
    export type SaveBudgetMutationVariables = {data: BudgetIn}

    /**
 * @summary Save Budget
 */
export const useSaveBudget = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveBudget>>, TError,SaveBudgetMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveBudget>>,
        TError,
        SaveBudgetMutationVariables,
        TContext
      > => {
      return useMutation(getSaveBudgetMutationOptions(options), queryClient);
    }
    export type getReportResponse200 = {
  data: ReportOut
  status: 200
}

export type getReportResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getReportResponseSuccess = (getReportResponse200) & {
  headers: Headers;
};
export type getReportResponseError = (getReportResponse422) & {
  headers: Headers;
};

export type getReportResponse = (getReportResponseSuccess | getReportResponseError)

export const getGetReportUrl = (name: ReportName,
    params?: GetReportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/${name}?${stringifiedParams}` : `/api/reports/${name}`
}

/**
 * @summary Get Report
 */
export const getReport = async (name: ReportName,
    params?: GetReportParams, options?: Parameters<typeof apiFetch>[1]): Promise<getReportResponse> => {

  return apiFetch<getReportResponse>(getGetReportUrl(name,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetReportQueryKey = (name: ReportName,
    params?: GetReportParams,) => {
    return [
    `/api/reports/${name}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetReportQueryOptions = <TData = Awaited<ReturnType<typeof getReport>>, TError = HTTPValidationError>(name: ReportName,
    params?: GetReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportQueryKey(name,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReport>>> = ({ signal }) => getReport(name,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: name !== null && name !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportQueryResult = NonNullable<Awaited<ReturnType<typeof getReport>>>
export type GetReportQueryError = HTTPValidationError


export function useGetReport<TData = Awaited<ReturnType<typeof getReport>>, TError = HTTPValidationError>(
 name: ReportName,
    params: undefined |  GetReportParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReport>>,
          TError,
          Awaited<ReturnType<typeof getReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReport<TData = Awaited<ReturnType<typeof getReport>>, TError = HTTPValidationError>(
 name: ReportName,
    params?: GetReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReport>>,
          TError,
          Awaited<ReturnType<typeof getReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReport<TData = Awaited<ReturnType<typeof getReport>>, TError = HTTPValidationError>(
 name: ReportName,
    params?: GetReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Report
 */

export function useGetReport<TData = Awaited<ReturnType<typeof getReport>>, TError = HTTPValidationError>(
 name: ReportName,
    params?: GetReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReportQueryOptions(name,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type exportReportResponse200 = {
  data: Blob
  status: 200
}

export type exportReportResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type exportReportResponseSuccess = (exportReportResponse200) & {
  headers: Headers;
};
export type exportReportResponseError = (exportReportResponse422) & {
  headers: Headers;
};

export type exportReportResponse = (exportReportResponseSuccess | exportReportResponseError)

export const getExportReportUrl = (name: ReportName,
    params?: ExportReportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/reports/${name}/export?${stringifiedParams}` : `/api/reports/${name}/export`
}

/**
 * @summary Export Report
 */
export const exportReport = async (name: ReportName,
    params?: ExportReportParams, options?: Parameters<typeof apiFetch>[1]): Promise<exportReportResponse> => {

  return apiFetch<exportReportResponse>(getExportReportUrl(name,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportReportQueryKey = (name: ReportName,
    params?: ExportReportParams,) => {
    return [
    `/api/reports/${name}/export`, ...(params ? [params] : [])
    ] as const;
    }


export const getExportReportQueryOptions = <TData = Awaited<ReturnType<typeof exportReport>>, TError = HTTPValidationError>(name: ReportName,
    params?: ExportReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportReport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportReportQueryKey(name,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportReport>>> = ({ signal }) => exportReport(name,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: name !== null && name !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportReportQueryResult = NonNullable<Awaited<ReturnType<typeof exportReport>>>
export type ExportReportQueryError = HTTPValidationError


export function useExportReport<TData = Awaited<ReturnType<typeof exportReport>>, TError = HTTPValidationError>(
 name: ReportName,
    params: undefined |  ExportReportParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportReport>>,
          TError,
          Awaited<ReturnType<typeof exportReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportReport<TData = Awaited<ReturnType<typeof exportReport>>, TError = HTTPValidationError>(
 name: ReportName,
    params?: ExportReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportReport>>,
          TError,
          Awaited<ReturnType<typeof exportReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportReport<TData = Awaited<ReturnType<typeof exportReport>>, TError = HTTPValidationError>(
 name: ReportName,
    params?: ExportReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportReport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export Report
 */

export function useExportReport<TData = Awaited<ReturnType<typeof exportReport>>, TError = HTTPValidationError>(
 name: ReportName,
    params?: ExportReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportReport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportReportQueryOptions(name,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






